import {
  ActionIcon, Button, Center, Container, Loader, MantineProvider,
  Table, TextInput, ThemeIcon, Title, useMantineTheme
} from "@mantine/core";
import {
  IconArrowLeft, IconArrowRight, IconSearch,
  IconCloudDownload, IconX
} from "@tabler/icons-react";
import { useDispatch, useSelector } from 'react-redux';
import { setUrl, setUrls, updateInPlace, updateOrAddUrl } from '../entrypoints/videoSlice';
import * as React from "react";
import {useEffect} from "react";

interface Url {
  id?: number;
  url: string;
  title: string;
  status: 'completed' | 'processing' | 'failed';
}

interface AppState {
  video: {
    urls: Url[];
    url: string;
  };
}

interface InputWithButtonProps {
  value: string;
  urls: Url[];
}

const App: React.FC = () => {
  const urls = useSelector((state: AppState) => state.video.urls);
  const url = useSelector((state: AppState) => state.video.url);
  const dispatch = useDispatch();

  useEffect(() => {
    fetch('/api/v1/videos')
      .then((res) => res.json())
      .then((data) => dispatch(setUrls(data)));
  }, [dispatch]);

  return (
    <MantineProvider withGlobalStyles withNormalizeCSS>
      <Container mt="md">
        <Title align="center">I'm Still Oscar.com</Title>
        <InputWithButton value={url} urls={urls} />
        <DemoTable urls={urls} />
      </Container>
    </MantineProvider>
  );
};

export default App;

export const InputWithButton: React.FC<InputWithButtonProps> = (props) => {
  const dispatch = useDispatch();
  const theme = useMantineTheme();
  const onSubmit = (e) => {
    e.preventDefault();
    const urlToAdd = props.value.replace(/\s/g, '');
    const requestOptions = {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({video: {url: urlToAdd}})
    };

    // add base URL to list
    dispatch(updateOrAddUrl({url: urlToAdd, status: "processing"}))
    dispatch(setUrl(''));

    // call API and set existing URL with new URL
    fetch('/api/v1/videos', requestOptions)
      .then((res) => res.json())
      .then((data) => {
        dispatch(updateInPlace(data));
      })
  }

  return (
    <form onSubmit={onSubmit}>
      <TextInput
        onChange={(e) => dispatch(setUrl(e.currentTarget.value))}
        icon={<IconSearch size="1.1rem" stroke={1.5}/>}
        radius="xl"
        m="lg"
        mb="xl"
        size="lg"
        rightSection={
          <ActionIcon size={32} radius="xl" color={theme.primaryColor} variant="filled" onClick={onSubmit}>
            {theme.dir === 'ltr' ? (
              <IconArrowRight size="1.1rem" stroke={1.5}/>
            ) : (
              <IconArrowLeft size="1.1rem" stroke={1.5}/>
            )}
          </ActionIcon>
        }
        placeholder="Grab a youtubes"
        rightSectionWidth={42}
        {...props}
      />
    </form>
  );
}

const DemoTable: React.FC<{ urls: Url[] }> = (props) => {
  const dispatch = useDispatch();
  const urls = useSelector((state: AppState) => state.video.urls);

  const removeRow = (e) => {
    const id = e.currentTarget.value;
    const requestOptions = {
      method: 'DELETE',
      headers: {'Content-Type': 'application/json'}
    };

    dispatch(setUrls(urls.filter(url => (url.id.toString() !== id))));

    fetch(`/api/v1/videos/${e.currentTarget.value}`, requestOptions)
      .then((res) => res.json())
  }
  const rows = props.urls.map((url) => (
    <tr key={url.url}>
      <td>
        <Center>
          {url.status === "completed" && (
            <a href={`download/${url.id}`}>
            <ThemeIcon variant="light" size="sm" radius="sm" color="blue">
              <IconCloudDownload/>
            </ThemeIcon>
            </a>
          )}
          {url.status === "failed" && (
            <ThemeIcon variant="light" size="sm" radius="sm" color="red">
              <IconX/>
            </ThemeIcon>
          )}
          {url.status === "processing" && (
            <Loader size="xs" color="yellow"/>
          )}
        </Center>
      </td>
      <td>
        {url.status === "completed" ? (
          <a href={`/download/${url.id}`}>{url.title}</a>
        ) : (
          url.title
        )}

      </td>
      <td><a href={url.url} target={"_blank"}>{url.url}</a></td>
      <td>
        {(url.id !== undefined) && (
          <Button color="red" size="xs" compact onClick={removeRow} value={url.id}>Remove</Button>
        )}
      </td>
    </tr>
  ));

  return (
    <Table>
      <thead>
      <tr>
        <th><Center>Status</Center></th>
        <th>Title</th>
        <th>URL</th>
        <th></th>
      </tr>
      </thead>
      <tbody>{rows}</tbody>
    </Table>
  );
}

